import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button, Label ,Container, Input, Form, Table} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import SweetAlert from "react-bootstrap-sweetalert";
import firebase from '../../firebase';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faEdit, faInfo, faSearch } from "@fortawesome/free-solid-svg-icons";
import { Redirect } from "react-router-dom";
import Select from 'react-select';
import ModalHeader from "reactstrap/lib/ModalHeader";
import ModalBody from "reactstrap/lib/ModalBody";
import Modal from "reactstrap/lib/Modal";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { TablePagination } from '@material-ui/core';
import Loader from "react-loader-spinner";
import axios from "axios";
import { API_BASE_URL, API_KEY, getCookie, renewAccessToken, setCookie, handleRenewAccessTokenError , sessionExpired, API_BASE_URL_2 } from "../../constants/utilis";
import { fetchVerifiedCaseListHelper } from "../../constants/completedCaseNotification";
import PdfEvaluator from "./pdfEvaluator";

function formatDate(date) {
	var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
    if (month.length < 2)
    month = '0' + month;
    if (day.length < 2)
    day = '0' + day;
    return [year, month, day].join('-');
}


class VerifiedCasse extends Component {
  constructor(props) {
    super(props);
    this.fetchList = this.fetchList.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.getCaseDetails = this.getCaseDetails.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
    this.funcMap = {
        '1': this.fetchList,
        '2': this.handleSubmit,
        '3': this.handleFilter,
        '5': this.getCaseDetails,
        '98': this.handleChangePage,
        '99': this.handleChangeRowsPerPage
    };
    this.state = {
      firebaseData: [],
      isFirstLoad: true,
      firebaseData1: [],
      totalFilteredData: [],
      videoName: '',
      menu: 'Select',
      success_msg: false,
      agents: [],
      agentId: [],
      isClearable: true,
      isDisabled: false,
      isLoading: false,
      isRtl: false,
      isSearchable: true,
      banks: [],
      products: [],
      bank: '',
      product: '',
      infoData: [],
      infoType: '',
      moveToView: false,
      moveToEdit: false,
      applicationId: '',
      startDate: '',
      endDate: '',
      openModal: false,
      applicationId: '',
      customerName: '',
      mobileNumber: '',
      productName: '' ,
      rvAddress: '',
      bvAddress: '',
      pvAddress: '',

      pages: [30, 50, 100, 300, 500],
      page: 0,
      rowsPerPage: 30,
      lastVisible: {},
      queryParams: {},
      count: 0,
      totalRecords: 0
    };
  }

  handleChangePage(event, newPage) {
    this.setState({
      page: newPage
    })

    let comp = this
    let jsonData = comp.state.queryParams

    jsonData.pagination = true
    jsonData.pageSize = comp.state.rowsPerPage
    jsonData.pageCount = Number(newPage) + 1

    let jsonData1 = JSON.stringify(jsonData);

    var config = {
      method: 'post',
      url: API_BASE_URL + '/auth/report/verifedCase',
      headers: { 
        apikey: API_KEY, 
        Authorization: "Bearer " + getCookie("at"),
        'Content-Type': 'application/json'
      },
      data: jsonData1
    };
    
    axios(config)
    .then(function (response) {
        if(response.status == 200) {
          comp.setState({
            firebaseData: response.data.caseList,
            totalFilteredData: response.data.totalFilteredData,
            totalRecords: response.data.totalRecords
          })
        }
    })
    .catch(function (error) {
      console.log(error);
      comp.handleNon200Response(error, "98");
    });
  }
  
  handleChangeRowsPerPage(event) {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    })

    let comp = this
    let jsonData = comp.state.queryParams

    jsonData.pagination = true
    jsonData.pageSize = parseInt(event.target.value, 10)
    jsonData.pageCount = Number(0) + 1

    let jsonData1 = JSON.stringify(jsonData);

    var config = {
      method: 'post',
      url: API_BASE_URL + '/auth/report/verifedCase',
      headers: { 
        apikey: API_KEY, 
        Authorization: "Bearer " + getCookie("at"),
        'Content-Type': 'application/json'
      },
      data: jsonData1
    };
    
    axios(config)
    .then(function (response) {
        if(response.status == 200) {
          comp.setState({
            firebaseData: response.data.caseList,
            totalFilteredData: response.data.totalFilteredData,
            totalRecords: response.data.totalRecords
          })
        }
    })
    .catch(function (error) {
      console.log(error);
      comp.handleNon200Response(error, "99");
    });
  }

  componentDidMount() {
    let comp = this


    // verified case notification
    // fetchVerifiedCaseListHelper(this);

    // this.autoRefreshInterval = setInterval(() => {
    //   fetchVerifiedCaseListHelper(this);
    // }, 30000);

    var state = localStorage.getItem("state")
    if(state === null) {
        state = sessionStorage.getItem("state")
    }


    var config1 = {
      method: 'get',
      url: API_BASE_URL + '/auth/bank',
      headers: { 
        apikey: API_KEY, 
        Authorization: "Bearer " + getCookie("at"),
      }
    };
    
    axios(config1)
    .then(function (response1) {
      comp.setState({
        banks: response1.data
      })
    })
    .catch(function (error) {
      console.log(error);
      comp.handleNon200Response(error, "1");
    });

    var config2 = {
      method: 'get',
      url: API_BASE_URL + '/auth/loanproduct',
      headers: { 
        apikey: API_KEY, 
        Authorization: "Bearer " + getCookie("at"),
      }
    };
    
    axios(config2)
    .then(function (response2) {
      comp.setState({
        products: response2.data
      })
    })
    .catch(function (error) {
      console.log(error);
      // comp.handleNon200Response(error, "1");
    });  

    const pushedData = JSON.parse(localStorage.getItem('pushedData')) || {};
    this.setState({ pushedData });
    comp.fetchList()

  }

  // componentWillUnmount() {
  //   // Clear the interval to prevent memory leaks
  //   clearInterval(this.autoRefreshInterval);
  // }

  async fetchList() {
    let comp = this

    var state = localStorage.getItem("state")
    if(state === null) {
        state = sessionStorage.getItem("state")
    }

    console.log(state)

    var today = new Date()
    var currentDate = formatDate(today)  

    let jsonData = {
      state: state.split(",").slice(0, -1),
      currentDate: currentDate
    };

    let bank = localStorage.getItem("bank")
    if(bank === null) {
        bank = sessionStorage.getItem("bank")
    }

    if(!bank.includes("SUPER ADMIN")) {
      jsonData.bank = bank.split(",").slice(0, -1)
    }

    comp.setState({
      queryParams: jsonData
    })

    jsonData.pagination = true
    jsonData.pageSize = comp.state.rowsPerPage
    jsonData.pageCount = Number(comp.state.page) + 1

    let jsonData1 = JSON.stringify(jsonData);

    var config = {
      method: 'post',
      url: API_BASE_URL + '/auth/report/verifedCase',
      headers: { 
        apikey: API_KEY, 
        Authorization: "Bearer " + getCookie("at"),
        'Content-Type': 'application/json'
      },
      data: jsonData1
    };
    
    axios(config)
    .then(function (response) {
        if(response.status == 200) {
          comp.setState({
            firebaseData: response.data.caseList,
            totalFilteredData: response.data.totalFilteredData,
            totalRecords: response.data.totalRecords,
            // isFirstLoad: false,
          })
        }
    })
    .catch(function (error) {
      console.log(error);
      // comp.handleNon200Response(error, "1");
    });
  }

  searchByApplicationId(e) {
    let data = this.state
    let comp = this

    var state = localStorage.getItem("state")
    if(state === null) {
        state = sessionStorage.getItem("state")
    }

    comp.setState({
      firebaseData: [],
      totalFilteredData: []
    })

    if(data.applicationId === '') {
      alert("Enter Application ID")
      document.getElementById("applicationId").focus()
      return
    }

    let jsonData = {
      state: state.split(",").slice(0, -1),
      applicationId: data.applicationId
    }

    let bank = localStorage.getItem("bank")
    if(bank === null) {
        bank = sessionStorage.getItem("bank")
    }

    if(!bank.includes("SUPER ADMIN")) {
      jsonData.bank = bank.split(",").slice(0, -1)
    }

    let jsonData1 = JSON.stringify(jsonData);

    var config = {
      method: 'post',
      url: API_BASE_URL + '/auth/verifiedCase/searchByApplicationId',
      headers: { 
        apikey: API_KEY, 
        Authorization: "Bearer " + getCookie("at"),
        'Content-Type': 'application/json'
      },
      data: jsonData1
    };
    
    axios(config)
    .then(function (response) {
        console.log(response.data)
        if(response.status == 200) {
              comp.setState({
                firebaseData: response.data,
                totalFilteredData: response.data,
                totalRecords: 1,
            })
        }
    })
    .catch(function (error) {
      console.log(error);
      comp.handleNon200Response(error, "4");
    });
  }

  agentsOnChange = agentId => {
    this.setState({ agentId });
  }


  handleChange(event) {
    this.setState({
        [event.target.name]: event.target.value
    });
  }

  handleNon200Response = (error, functionIndex) => {
    if(error.response.status == 401 && error.response.data.message == "User Not authenticated") {
      sessionExpired();
    } 
  }

  handleSubmit(e) {
    e.preventDefault();

    let data = this.state
    let comp = this

    var state = localStorage.getItem("state")
    if(state === null) {
        state = sessionStorage.getItem("state")
    }

    let jsonData = {
      state: state.split(",").slice(0, -1),
    }

    var bank = localStorage.getItem("bank")
    if(bank === null) {
        bank = sessionStorage.getItem("bank")
    }

    if(!bank.includes("SUPER ADMIN")) {
      jsonData.bank = bank.split(",").slice(0, -1)
    }

    if(data.product !== "") {
      jsonData.product = data.product
    }

    comp.setState({
      queryParams: jsonData
    })

    jsonData.pagination = true
    jsonData.pageSize = comp.state.rowsPerPage
    jsonData.pageCount = Number(comp.state.page) + 1

    var jsonData1 = JSON.stringify(jsonData);

    var config = {
      method: 'post',
      url: API_BASE_URL + '/auth/report/verifedCase',
      headers: { 
        apikey: API_KEY, 
        Authorization: "Bearer " + getCookie("at"),
        'Content-Type': 'application/json'
      },
      data: jsonData1
    };
    
    axios(config)
    .then(function (response) {
        console.log(response.data)
        if(response.status == 200) {
              comp.setState({
                firebaseData: response.data.caseList,
                totalFilteredData: response.data.totalFilteredData,
                totalRecords: response.data.totalRecords
            })
        }
    })
    .catch(function (error) {
      console.log(error);
      comp.handleNon200Response(error, "2");
    });
}

handleFilter(e) {
  e.preventDefault();

  let data = this.state
  let comp = this

  if (data.startDate === '') {
      alert("Select Start date");
      document.getElementById("startDate").focus();
      return;
  }

  if (data.endDate === '') {
      alert("Select End Date");
      document.getElementById("endDate").focus();
      return;
  }

  let checkBank = localStorage.getItem("bank")

  if (checkBank === null) {
      checkBank = sessionStorage.getItem("bank");
  }

  var jsonData = {
      state: "SUPER ADMIN",
      startDate: data.startDate,
      endDate: data.endDate,
      bank: checkBank,
  };

  if(checkBank !== "" || !checkBank.includes("SUPER ADMIN")) {
      if(data.bank == "DMI FINANCE PRIVATE LIMITED"  || data.bank == "DMI FINANCE PRIVATE LIMITED,"){ // select field value
        jsonData.bank = ["DMI FINANCE PRIVATE LIMITED", "DMI FINANCIAL PRIVATE LIMITED", "DMI Finance Pvt. Ltd."];
      }
      else {
        jsonData.bank = data.bank || checkBank.split(",").slice(0, -1);
      }
  }

  if (!data.startDate) {
    delete jsonData.startDate; // Remove startDate if not selected
  }

  if (!data.endDate) {
    delete jsonData.endDate; // Remove endDate if not selected
  }

  // console.log("dfghjk", data.bank, "ggg", checkBank);

  if(checkBank.includes("SUPER ADMIN") && !data.bank) {
    delete jsonData.bank;
  }

  comp.setState({
      queryParams: jsonData
  })

  jsonData.pagination = true
  jsonData.pageSize = comp.state.rowsPerPage
  jsonData.pageCount = Number(comp.state.page) + 1

  let jsonData1 = JSON.stringify(jsonData);


  var config = {
    method: 'post',
    url: API_BASE_URL + '/auth/report/verifedCase',
    headers: { 
      apikey: API_KEY, 
      Authorization: "Bearer " + getCookie("at"),
      'Content-Type': 'application/json',
    },
    data: jsonData1
  };
  
  axios(config)
  .then(function (response) {
      console.log(response.data)
      if(response.status == 200) {
            comp.setState({
              firebaseData: response.data.caseList,
              totalFilteredData: response.data.totalFilteredData,
              totalRecords: response.data.totalRecords
          })
      }
  })
  .catch(function (error) {
    console.log(error);
    comp.handleNon200Response(error, "3");
  });
}

  myFunction() {
    var input, filter, table, tr, td1,td2,td3,td4,td5,td6,td7,td8,td9,td10,td11,td12;
    var i,txtValue1,txtValue2,txtValue3,txtValue4,txtValue5,txtValue6,txtValue7,txtValue8,txtValue9,txtValue10,txtValue11,txtValue12;
    input = document.getElementById("search");
    filter = input.value.toUprCase();
    table = document.getElementById("dataTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
    td1 = tr[i].getElementsByTagName("td")[1];
    td2 = tr[i].getElementsByTagName("td")[2];
    td3 = tr[i].getElementsByTagName("td")[3];
    td4 = tr[i].getElementsByTagName("td")[4];
    td5 = tr[i].getElementsByTagName("td")[5];
    td6 = tr[i].getElementsByTagName("td")[6];
    td7 = tr[i].getElementsByTagName("td")[7];
    td8 = tr[i].getElementsByTagName("td")[8];
    if (td1) {
      txtValue1 = td1.textContent || td1.innerText;
      txtValue2 = td2.textContent || td2.innerText;
      txtValue3 = td3.textContent || td3.innerText;
      txtValue4 = td4.textContent || td4.innerText;
      txtValue5 = td5.textContent || td5.innerText;
      txtValue6 = td6.textContent || td6.innerText;
      txtValue7 = td7.textContent || td7.innerText;
      txtValue8 = td8.textContent || td8.innerText;
    
    var main = txtValue1+ txtValue2+txtValue3+txtValue4+txtValue5+txtValue6 + txtValue7+ txtValue8;
      if (main.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }       
  }
  }

  viewInfo(key) {
    let comp = this

    sessionStorage.setItem("caseId", key._id)
    sessionStorage.setItem("fromComp", "verify")

    window.open("/view-case")
    
    // comp.setState({
    //   moveToView: true
    // })
  }

  editInfo(key) {
    let comp = this

    sessionStorage.setItem("caseId", key._id)

    window.open("/edit-case")

    // comp.setState({
    //   moveToEdit: true
    // })
  }

  toggle() {
    let comp = this

    comp.setState({
      openModal: false
    })
  }

  getCaseDetails(key) {
    let comp = this

    console.log(key)

    let rvAddress = []
    let bvAddress = []
    let pvAddress = []

    comp.setState({
      rvAddress: '',
      bvAddress: '',
      pvAddress: ''
    })

    var state = localStorage.getItem("state")
    if(state === null) {
        state = sessionStorage.getItem("state")
    }

    var jsonData = JSON.stringify({
      state: state.split(",").slice(0, -1),
      applicationId: key.applicationid
    })


    var config = {
      method: "post",
      url: API_BASE_URL + "/auth/case/searchByApplicationId",
      headers: {
        apikey: API_KEY,
        Authorization: "Bearer " + getCookie("at"),
        "Content-Type": "application/json",
      },
      data: jsonData,
    }

    axios(config)
      .then(function (response) {
        if (response.status == 200) {
            for(let i=0; i< response.data.length; i++) {
              rvAddress.push(response.data[i].residenceaddress)
              bvAddress.push(response.data[i].officeaddress)
              pvAddress.push(response.data[i].permanentaddress)
            }

            for(let i = 0; i< rvAddress.length; i++) {
              if(rvAddress[i] !== undefined) {
                comp.setState({
                  rvAddress: rvAddress[i]
                })
              }
            }
      
            for(let i = 0; i< bvAddress.length; i++) {
              if(bvAddress[i] !== undefined) {
                comp.setState({
                  bvAddress: bvAddress[i]
                })
              }
            }
            for(let i = 0; i< pvAddress.length; i++) {
              if(pvAddress[i] !== undefined) {
                comp.setState({
                  pvAddress: pvAddress[i]
                })
              }
            }
          
            comp.setState({
              applicationId: key.applicationid,
              customerName: key.customername,
              mobileNumber: key.mobilenumber,
              productName: key.productname,
              openModal: true
          })
        }
      })
      .catch(function (error) {
        console.log(error.response.data)
        comp.handleNon200Response(error, "5")
      })
}

exportToCSV(fileName) {

  let comp = this

    // Get the filtered data or fallback to the full data
    let dataToExport = comp.state.firebaseData;

    if (!dataToExport || dataToExport.length === 0) {
      // Fetch the full data here if needed, otherwise fallback to an empty array.
      dataToExport = []; // or fetch the original dataset here
    }
  
    let loans = [];
  
    // Process the data for export
    if (dataToExport.length > 0) {
      for (let i = 0; i < dataToExport.length; i++) {
        const loan = {
          SL_No : i+1,
          ApplicationId: dataToExport[i].applicationid,
          CustomerName: dataToExport[i].customername,
          Bank: dataToExport[i].bank,
          Product: dataToExport[i].productname,
          CaseType: dataToExport[i].fi,
          TATTime: dataToExport[i].tattime,
          AgentName: dataToExport[i].agentname,
          Status: dataToExport[i].status,
          Allocation_Date_Time: (dataToExport[i].createdat == undefined || dataToExport[i].createdat == "") ? "" : dataToExport[i].createdat.slice(0, 10),
          Completion_Date_Time: (dataToExport[i].submittedat == undefined || dataToExport[i].submittedat == "") ? "" : dataToExport[i].submittedat.slice(0, 10),
          CPV_Status: (dataToExport[i].qcpvstatus == undefined) ? "" : dataToExport[i].qcpvstatus,
          Reject_Reason: (dataToExport[i].qrejectreason == undefined) ? "" : dataToExport[i].qrejectreason,
          // Address :(dataToExport[i].residenceaddress) ? dataToExport[i].residenceaddress : (dataToExport[i].officeaddress) ? dataToExport[i].officeaddress : "",
          // Contact_Number: dataToExport[i].mobilenumber,
          DataSentToClient: (dataToExport[i].pushDataTime.length > 0) ? "Yes" : "No",
        }

        if(sessionStorage.getItem('position') === 'Super Admin'){
          loan.Address = (dataToExport[i].residenceaddress) ? dataToExport[i].residenceaddress : (dataToExport[i].officeaddress) ? dataToExport[i].officeaddress : "";
          loan.Contact_Number = dataToExport[i].mobilenumber;
        }
        loans.push(loan);
      }
    }

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(loans);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(data, fileName + fileExtension);

  // let comp = this
  //   let jsonData = comp.state.queryParams

  //   console.log("CSV")

  //   jsonData.pagination = true
  //   jsonData.pageSize = 999999
  //   jsonData.pageCount = 1
  //   console.log("jsonData", jsonData)
	

  //   // var state = localStorage.getItem("state")
  //   // if(state === null) {
  //   //     state = sessionStorage.getItem("state")
  //   // }
    
  //   // jsonData.state = state.split(",").slice(0, -1);

  //   // let bank = localStorage.getItem("bank")
  //   // if(bank === null) {
  //   //     bank = sessionStorage.getItem("bank")
  //   // }

  //   // if(!bank.includes("SUPER ADMIN")) {
  //   //   jsonData.bank = bank.split(",").slice(0, -1)
  //   // }

  //   let jsonData1 = JSON.stringify(jsonData);

  //   var config = {
  //     method: 'post',
  //     url: API_BASE_URL + '/auth/report/verifedCase',
  //     headers: { 
  //       apikey: API_KEY, 
  //       Authorization: "Bearer " + getCookie("at"),
  //       'Content-Type': 'application/json'
  //     },
  //     data: jsonData1
  //   };
    
  //   axios(config)
  //   .then(function (response) {
	// console.log("response", response)    
  //       let loans = []
  //       if(response.status == 200) {
  //         for(let i=0; i< response.data.caseList.length; i++) {
  //           const loan = {
  //             ApplicationId: response.data.caseList[i].applicationid,
  //             CustomerName: response.data.caseList[i].customername,
  //             Bank: response.data.caseList[i].bank,
  //             Product: response.data.caseList[i].productname,
  //             CaseType: response.data.caseList[i].fi,
  //             TATTime: response.data.caseList[i].tattime,
  //             AgentName: response.data.caseList[i].agentname,
  //             Status: response.data.caseList[i].status,
  //             Allocation_Date_Time: (response.data.caseList[i].createdat == undefined || response.data.caseList[i].createdat == "") ? "": response.data.caseList[i].createdat.slice(0, 10),
  //             Completion_Date_Time: (response.data.caseList[i].submittedat == undefined || response.data.caseList[i].submittedat == "") ? "": response.data.caseList[i].submittedat.slice(0, 10),
  //             CPV_Status: (response.data.caseList[i].qcpvstatus == undefined) ? "": response.data.caseList[i].qcpvstatus,
  //             Reject_Reason:(response.data.caseList[i].qrejectreason == undefined) ? "": response.data.caseList[i].qrejectreason,
  //           }
  //           loans.push(loan)
  //         }
  //       }

  //         const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  //         const fileExtension = '.xlsx';
  //         const ws = XLSX.utils.json_to_sheet(loans);
  //         const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  //         const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  //         const data = new Blob([excelBuffer], {type: fileType});
  //         FileSaver.saveAs(data, fileName + fileExtension);
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //     comp.handleNon200Response(error, "1");
  //   });
}

pushDataToClient(key) {

  if (!key.qcpvstatus || key.qcpvstatus.trim() === '') {
    alert("CPV Status is undefined or empty.");
    return;
  }

  const url = (key.bank === 'Flexiloans' || key.bank === 'FLEXILOAN')
    ? API_BASE_URL + '/auth/pushCaseDataFlexiloans/' + key._id
    : API_BASE_URL + '/auth/pushCaseData/' + key._id;
  var config = {
    method: 'put',
    url: url,
    headers: { 
      apikey: API_KEY, 
      Authorization: "Bearer " + getCookie("at"),
      'Content-Type': 'application/json'
    },
  };

  axios.request(config)
    .then((response) => {
        console.log(JSON.stringify(response.data));
        alert("Data Pushed Successfully!!")

        const updatedCase = response.data;
        console.log("Updated Push Data Times:", updatedCase.pushDataTime);

    })
    .catch((error) => {
        console.log(error);
        console.log("Error in Push Data Times:", error.response.data.message);
        alert(error.response.data.message);
    });
}

  handleEvaluate = (caseData) => {
    sessionStorage.setItem("caseId", caseData._id)
    window.open('/pdf-evaluator');
  };

  render() {

    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };

    let bank = localStorage.getItem("bank") || sessionStorage.getItem("bank") || "";
    const isSuperAdmin = bank.includes("SUPER ADMIN")
    // const { pushedData } = this.state;
  
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            {this.state.moveToView ? <Redirect to = "view-case" /> : null}
            {this.state.moveToEdit ? <Redirect to = "edit-case" /> : null}
            <Breadcrumbs title="Case" breadcrumbItem="Verified Case" />


                    <Row id = "case-list">
                            <Col lg={12}>
                                <Card>
                                    <CardBody id = "user-list">
                                    {this.state.firebaseData.length == 0 ? 
                                    <Loader 
                                        type="Circles" 
                                        color="#4058b0" 
                                        height={130} 
                                        width={130}
                                        timeout={10000}
                                        style = {{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 2 }}
                                    /> : null }
                                      <Row>
                                        <Col md = {3} className = "input-group">
                                                <input className="form-control" placeholder = "Application ID"  type="applicationId" name="applicationId" id="applicationId" value = {this.state.applicationId}  onChange = {this.handleChange.bind(this)} />
                                                <span className="input-group-append">
                                                    <button className="btn btn-outline-secondary" type="button" id="search">
                                                    <FontAwesomeIcon style = {{fontSize: "10px", cursor: "pointer"}} icon={faSearch} onClick = {this.searchByApplicationId.bind(this)}/>
                                                    </button>
                                                </span>
                                            </Col>
                                            <Col md = "7"></Col>
                                            <Col md = "2">
                                            <Button color="primary" onClick = {this.exportToCSV.bind(this, "Verified Case")} type="submit">Excel</Button>
                                            </Col>
                                        </Row>
                                        <br />

                                          <Row>
                                              {/* <Col md = {{size: 3}}>
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom05">Bank<span style = {{color: "red"}}>*</span></Label>
                                                        <Input type="select"  value = {this.state.bank} id = "bank" name = "bank" onChange = {this.handleChange.bind(this)}>
                                                        <option value = "">Select Bank</option>
                                                          {this.state.banks.map((rowData, index) => (
                                                            <option value = {rowData.name}>{rowData.name}</option>
                                                          ))}
                                                      </Input>
                                                    </FormGroup>
                                                </Col> */}
           
                                                <Col md = {{size: 3}}>
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom05">Products<span style = {{color: "red"}}>*</span></Label>
                                                        <Input type="select"  value = {this.state.product} id = "product" name = "product" onChange = {this.handleChange.bind(this)}>
                                                        <option value = "">Select Product</option>
                                                          {this.state.products.map((rowData, index) => (
                                                            <option value = {rowData.name}>{rowData.name}</option>
                                                          ))}
                                                      </Input>
                                                    </FormGroup>
                                                </Col>
                                                <Col md = {{size: 3}} style = {{margin: "auto"}}>
                                              <Button color="primary" onClick = {this.handleSubmit.bind(this)} type="submit">Submit</Button>
                                              </Col>
                                              </Row>

                                              <Row>

                                                {isSuperAdmin && <Col md = {{size: 3}}>
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom05">Bank<span style = {{color: "red"}}>*</span></Label>
                                                        <Input type="select"  value = {this.state.bank} id = "bank" name = "bank" onChange = {this.handleChange.bind(this)}>
                                                        <option value = "">Select Bank</option>
                                                          {this.state.banks.map((rowData, index) => (
                                                            <option value = {rowData.name}>{rowData.name}</option>
                                                          ))}
                                                      </Input>
                                                    </FormGroup>
                                                </Col>}

                                                <Col md = {{size: 3}}>
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom05">Start Date<span style = {{color: "red"}}>*</span></Label>
                                                        <Input type="date"  value = {this.state.startDate} id = "startDate" name = "startDate" onChange = {this.handleChange.bind(this)}>
                                                      </Input>
                                                    </FormGroup>
                                                </Col>

                                                <Col md = {{size: 3}}>
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom05">End Date<span style = {{color: "red"}}>*</span></Label>
                                                        <Input type="date"  value = {this.state.endDate} id = "endDate" name = "endDate" onChange = {this.handleChange.bind(this)}>
                                                      </Input>
                                                    </FormGroup>
                                                </Col>
                                                <Col md = {{size: 3}} style = {{margin: "auto"}}>
                                                  <Button color="primary" onClick = {this.handleFilter.bind(this)} type="submit">Filter</Button>
                                                </Col>
                                              </Row>

                                        <br />

                                        <div className="table-responsive" data-pattern="priority-columns">
                                            <Table className="table mb-0 table-striped table-bordered" id = "dataTable">
                                                <thead>
                                                    <tr>
                                                            <th>Sl.No</th>
                                                            <th>Application Id</th>
                                                            <th>Customer Name</th>
                                                            <th>Bank</th>
                                                            <th>Product</th>
                                                            <th>Case Type</th>
                                                            <th>Case Created By</th>
                                                            <th>TAT Time</th>
                                                            <th style={{ backgroundColor: '#cce5ff'}}>Case Duration</th>
                                                            <th>Agent</th>
                                                            <th>CPV Status</th>
                                                            <th>Status</th>
                                                            <th>Case Assigned Date Time</th>
                                                            <th>Completion Date Time</th>
                                                            {/* <th>Location</th> */}
                                                            <th>Action</th>
                                                            <th>Analyse Case Report</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.firebaseData.map((rowData, index) => (
                                                  <>
                                                  {/* {bank.includes("SUPER ADMIN") || rowData.showToClient == "YES" ? */}
                                                    <tr key = {index}>
                                                        <td>{this.state.page * this.state.rowsPerPage + index + 1}</td>
                                                        <td onClick = {this.getCaseDetails.bind(this, rowData)} style = {{color: "#556EE6", cursor: "pointer"}}>{rowData.applicationid}
                                                        <br /><br />
                                                        {rowData.salesName !== undefined && rowData.salesName !== "" ? <p style={{color: "green"}}>Sales Agent: {rowData.salesName}</p> : null}
                                                        </td>
                                                        <td>{rowData.customername}</td>
                                                        <td>{rowData.bank}</td>
                                                        <td>{rowData.productname}</td>
                                                        <td>{rowData.fi}</td>
                                                        <td>{rowData.caseCreatedBy}</td>
                                                        <td>{rowData.tattime}</td>
                                                        <td 
                                                          style={{ backgroundColor:
                                                            rowData.caseRunningHour.hours < 4 ? 'green' :
                                                            rowData.caseRunningHour.hours < 5 ? 'orange' : 'red',
                                                            color: 'white', }}
                                                        >
                                                          {rowData.caseRunningHour.label}
                                                        </td>
                                                        <td>{rowData.agentname}</td>
                                                        <td>
                                                          {rowData.qcpvstatus === "Positive" ? (
                                                            <p style={{ color: "green" }}>Positive</p>
                                                          ) : rowData.qcpvstatus === "Negative" ? (
                                                            <p style={{ color: "red" }}>Negative</p>
                                                          ) : rowData.qcpvstatus === "No Service" ? (
                                                            <p style={{ color: "orange" }}>No Service</p>
                                                          ) : (
                                                            rowData.qcpvstatus
                                                          )}
                                                        </td>
                                                        <td>{rowData.status}</td>
                                                        <td>{rowData.submittedat !== "" ? new Date(rowData.caseAssignedTime).toLocaleDateString("en-US", options): ""}</td>
                                                        <td>{rowData.completedat !== "" ?  new Date(rowData.completedat).toLocaleDateString("en-US", options) : ""}</td>
                                                        {/* <td>{rowData.locationcoordinates.latitude + "," + rowData.LocationCoordinates.longitude}</td> */}
                                                        <td>
                                                          <Row>
                                                            <Col><FontAwesomeIcon style = {{cursor: "pointer"}} onClick = {this.viewInfo.bind(this, rowData)} icon = {faInfo} /></Col>
                                                            {/* EDIT BUTTON */}
                                                            <Col><FontAwesomeIcon style = {{cursor: "pointer"}} onClick = {this.editInfo.bind(this, rowData)} icon = {faEdit} /></Col> 
                                                          </Row>
                                                          <br />
                                                          {/* {rowData.bank === 'DMI FINANCE PRIVATE LIMITED' ?
                                                         <Button color="success" onClick = {this.pushDataToClient.bind(this, rowData)}  type="submit">Push Data</Button> : null } */}
                                                         {rowData.bank === 'DMI FINANCIAL PRIVATE LIMITED' || rowData.bank === 'DMI FINANCE PRIVATE LIMITED' || rowData.bank === "DMI Finance Pvt. Ltd." || rowData.bank === 'Flexiloans' || rowData.bank === 'FLEXILOAN' ? (
                                                            (Array.isArray(rowData.pushDataTime) && rowData.pushDataTime.length > 0) ? (
                                                              <Button 
                                                                color="success" 
                                                                onClick={() => this.pushDataToClient(rowData)}  
                                                                type="submit"
                                                              >
                                                                {/* Data pushed {rowData.pushDataTime} */}
                                                                Data pushed on {new Date(rowData.pushDataTime[rowData.pushDataTime.length - 1]).toLocaleDateString("en-US", options)}
                                                              </Button>
                                                            ) : (
                                                              <Button 
                                                                color="info" 
                                                                onClick={() => this.pushDataToClient(rowData)}  
                                                                type="submit"
                                                              >
                                                                Push Data
                                                              </Button>
                                                            )
                                                          ) : null}
                                                        </td>
                                                        <td>
                                                          <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => this.handleEvaluate(rowData)}
                                                            style={{ marginTop: 10 }}
                                                          >
                                                            Evaluate Report
                                                          </Button>
                                                        </td>
                                                     </tr>
                                                      {/* : null } */}
                                                     </>
                                                ))}                                                
                                                </tbody>
                                            </Table>
                                        </div>

                                        <TablePagination
                                                component="div"
                                                page={this.state.page}
                                                rowsPerPageOptions={this.state.pages}
                                                rowsPerPage={this.state.rowsPerPage}
                                                count={this.state.totalRecords}
                                                onChangePage={this.handleChangePage.bind(this)}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage.bind(this)}
                                          />

                                        <Modal isOpen={this.state.openModal} toggle={this.toggle.bind(this)}>
                                          <ModalHeader toggle={this.toggle.bind(this)}>{this.state.applicationId}</ModalHeader>
                                          <ModalBody>
                                            <Row>
                                              <Col md = {4}>
                                                <h6>Customer Name</h6>
                                              </Col>
                                              <Col md = {8}>
                                                <h6>: {this.state.customerName}</h6>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col md = {4}>
                                                <h6>Mobile Number</h6>
                                              </Col>
                                              <Col md = {8}>
                                                <h6>: {this.state.mobileNumber}</h6>
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col md = {4}>
                                                <h6>Product</h6>
                                              </Col>
                                              <Col md = {8}>
                                                <h6>: {this.state.productName}</h6>
                                              </Col>
                                            </Row>
                                            {this.state.pvAddress !== '' ?
                                            <Row>
                                              <Col md = {4}>
                                                <h6>PV Address</h6>
                                              </Col>
                                              <Col md = {8}>
                                                <h6>: {this.state.pvAddress}</h6>
                                              </Col>
                                            </Row> : null }
                                            {this.state.rvAddress !== '' ?
                                            <Row>
                                              <Col md = {4}>
                                                <h6>RV Address</h6>
                                              </Col>
                                              <Col md = {8}>
                                                <h6>: {this.state.rvAddress}</h6>
                                              </Col>
                                            </Row> : null }
                                            {this.state.bvAddress !== '' ?
                                            <Row>
                                              <Col md = {4}>
                                                <h6>BV Address</h6>
                                              </Col>
                                              <Col md = {8}>
                                                <h6>: {this.state.bvAddress}</h6>
                                              </Col>
                                            </Row> : null }
                                          </ModalBody>
                                        </Modal>

                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

          </Container>
          </div>
      </React.Fragment>
    );
  }
}

export default VerifiedCasse;
